import { render, staticRenderFns } from "./UnitSelectie.vue?vue&type=template&id=8c87ab12"
import script from "./UnitSelectie.vue?vue&type=script&lang=js"
export * from "./UnitSelectie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports